export const TEAM_MEMBERS_PREVIEW_DISPLAY_MAX = 20;

export const TEAM_MEMBERS_PREVIEW_QUERY_FIRST: number = TEAM_MEMBERS_PREVIEW_DISPLAY_MAX + 1;

export function formatTeamMembersPreviewCount(memberCount: number): string {
	return memberCount > TEAM_MEMBERS_PREVIEW_DISPLAY_MAX
		? `${TEAM_MEMBERS_PREVIEW_DISPLAY_MAX}+`
		: String(memberCount);
}
